import { API_URL_MAIN } from '@/config';
import { axios } from '@/lib/axios';

export type I_CheckUrlForgotPassword = {
  url_token: string;
};

export const checkUrlForgotPassword = (data: I_CheckUrlForgotPassword) => {
  return axios.post(`${API_URL_MAIN}/validate_url`, data,
  );
};
